import { useState, useMemo } from 'react';
import { SortDirection } from '../types/enums';
import { Sort } from '../types/table.type';

export default function useTableSort<T extends Record<string, any>>(data: T[]) {
  const [sortState, setSortState] = useState<{ key: string, direction: Sort }>({ key: '', direction: null });

  const handleSort = (key: string) => {
    let newDirection: Sort = SortDirection.Ascending;
    if (sortState.key === key) {
      if (sortState.direction === SortDirection.Ascending) newDirection = SortDirection.Descending;
      else if (sortState.direction === SortDirection.Descending) newDirection = null;
    }
    setSortState({
      key: newDirection ? key : '',
      direction: newDirection,
    });
  };

  const sortedData = useMemo(() => {
    if (!sortState.key || !sortState.direction) return data;

    const sorted = [...data].sort((a, b) => {
      const aVal = a[sortState.key];
      const bVal = b[sortState.key];

      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return aVal.localeCompare(bVal, 'en', { ignorePunctuation: true, sensitivity: 'base', numeric: true });
      }
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal;
      }
      return 0;
    });

    return sortState.direction === SortDirection.Descending ? sorted.reverse() : sorted;
  }, [data, sortState]);

  return { sortedData, sortState, handleSort };
}
